
import { createClient } from '@supabase/supabase-js';

const supabaseUrl = import.meta.env.VITE_PUBLIC_SUPABASE_URL;
const supabaseAnonKey = import.meta.env.VITE_PUBLIC_SUPABASE_ANON_KEY;

export const supabase = createClient(supabaseUrl, supabaseAnonKey);

export type Ad = {
  id: string;
  user_id: string;
  title: string;
  description: string | null;
  category: string;
  price: number | null;
  location: string | null;
  images: string[] | null;
  status: string | null;
  views: number | null;
  favorites: number | null;
  expires_at: string | null;
  created_at: string | null;
  updated_at: string | null;
};

export type Profile = {
  id: string;
  email: string | null;
  phone: string | null;
  full_name: string | null;
  avatar_url: string | null;
  status: string | null;
  created_at: string | null;
  updated_at: string | null;
};
